export default function ProspectsEmptyState() {
  return (
    <div className="empty-state">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M70 70L55 55M65 35C65 51.5685 51.5685 65 35 65C18.4315 65 5 51.5685 5 35C5 18.4315 18.4315 5 35 5C51.5685 5 65 18.4315 65 35Z" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <h3>Aucune recherche pour le moment</h3>
      <p>Lancez votre première recherche de prospects avec l'IA ci-dessus</p>
    </div>
  )
}
